"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoText = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const logo_text_style_1 = __importDefault(require("./logo.text.style"));
class LogoText extends react_1.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, axis, size, fill } = this.props;
            const style = {
                width: axis === 'x' ? size || '100%' : 'auto',
                height: axis === 'y' ? size || '100%' : 'auto'
            };
            return (jsx_runtime_1.jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 326 84", "aria-hidden": "true", className: classes.root, style: style }, { children: jsx_runtime_1.jsx("path", { "data-fill": fill, className: classes.type, d: "M58.633 13.068H34.6V0h61.83v13.068H72.282v69.764H58.633V13.068zM96.205 24.5h12.83v10.384c2.216-6.649 8.749-10.966 15.401-10.966 1.635 0 3.264.118 5.016.466v13.183c-2.218-.701-4.082-1.049-6.417-1.049-7.348 0-14 6.183-14 17.848v28.467h-12.83V24.5zM163.638 35c-10.382 0-17.38 8.166-17.38 18.667 0 10.5 6.998 18.665 17.38 18.665 10.384 0 17.386-8.165 17.386-18.665 0-10.501-7.002-18.667-17.386-18.667m-2.33-11.666c8.397 0 15.4 4.316 18.663 8.982v-7.817h12.832v58.333h-12.832v-7.816c-3.263 4.666-10.266 8.983-18.663 8.983-15.985 0-28.118-13.649-28.118-30.332 0-16.684 12.133-30.333 28.118-30.333M232.65 84c-17.501 0-30.8-13.067-30.8-30.332 0-17.268 13.299-30.335 30.8-30.335 12.014 0 22.164 6.417 27.182 16.099l-11.202 6.069c-2.797-5.953-8.515-10.268-15.98-10.268-10.382 0-17.734 8.05-17.734 18.435 0 10.382 7.352 18.43 17.734 18.43 7.465 0 13.183-4.315 15.98-10.266l11.202 6.067C254.814 77.583 244.664 84 232.65 84m46.905-36.867h32.435c-1.401-8.399-8.17-12.949-15.634-12.949-7.468 0-15.048 4.318-16.801 12.949m17.269-23.799c15.283 0 28.115 10.15 28.115 28.933 0 1.285 0 2.332-.118 4.201h-45.849c.583 9.566 8.285 15.865 17.968 15.865 8.165 0 13.649-3.733 16.68-8.867l9.8 6.999C318.17 78.75 309.072 84 296.824 84c-17.736 0-30.45-12.6-30.45-30.332 0-17.15 12.714-30.334 30.45-30.334" }, void 0) }), void 0));
        };
    }
}
exports.LogoText = LogoText;
LogoText.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    axis: prop_types_1.default.oneOf(['x', 'y']),
    size: prop_types_1.default.number,
    fill: prop_types_1.default.bool
};
LogoText.defaultProps = {
    axis: 'x',
    size: null,
    fill: false
};
exports.default = react_jss_1.default(logo_text_style_1.default)(LogoText);
//# sourceMappingURL=logo.text.js.map